import { ReactComponent as BaseSVG } from '../assets/ElectricityRegionNorway.svg';
import { ReactComponent as NO1SVG } from '../assets/ElectricityRegionNorway-NO1.svg';
import { ReactComponent as NO2SVG } from '../assets/ElectricityRegionNorway-NO2.svg';
import { ReactComponent as NO3SVG } from '../assets/ElectricityRegionNorway-NO3.svg';
import { ReactComponent as NO4SVG } from '../assets/ElectricityRegionNorway-NO4.svg';
import { ReactComponent as NO5SVG } from '../assets/ElectricityRegionNorway-NO5.svg';

const NorwayMap = ({ onRegionSelect, selectedRegion }) => {
    const handleClick = (region) => {
        if (onRegionSelect) {
            onRegionSelect(region);
        }
    };

    return (
        <div className="relative w-full max-w-[1000px] mx-auto h-[600px] hidden md:flex md:items-center md:justify-center">
            <BaseSVG className="absolute top-0 left-0 w-full h-full" preserveAspectRatio="xMidYMid meet" />
            <NO1SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'NO1' ? 'active-no1' : ''}`}
                onClick={() => handleClick('NO1')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <NO2SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'NO2' ? 'active-no2' : ''}`}
                onClick={() => handleClick('NO2')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <NO3SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'NO3' ? 'active-no3' : ''}`}
                onClick={() => handleClick('NO3')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            
            <NO5SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'NO5' ? 'active-no5' : ''}`}
                onClick={() => handleClick('NO5')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <NO4SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'NO4' ? 'active-no4' : ''}`}
                onClick={() => handleClick('NO4')} 
                preserveAspectRatio="xMidYMid meet"
            />
        </div>
    );
};

export default NorwayMap;